import React from "react";
import loadable from "../../shared/utils/loadable";
import { RouteProps } from "react-router-dom";
import { routeConstants } from "../../shared/constants";

const Route = loadable(import("./index"));

const DeliveryRoute: RouteProps = {
  path: routeConstants.delivery.route,
  element: React.createElement(Route),
};

export default DeliveryRoute;
